<div class="dd-v-spec-protection-products">
  <dd-vehicle-detail-header [vehicleDetails]="vehicle" [sharedData]="shared"></dd-vehicle-detail-header>
  <dd-app-menu></dd-app-menu>
  <div fxLayout="column" class="dd-content-margin">
    <dd-page-title [title]="'Base Financing Terms'"></dd-page-title>
  
  </div>

  <div fxLayout="column" fxLayoutGap="10px">
    <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap="30px" class="dd-content-margin pp-container">


    </div>
    <div class="dd-content-margin">
      <div class="dd-products-container">
        <div  *ngIf="paymentType=='Retail'" class="dd-pp-container">
          <div class="dd-para-title">
            <span class="dd-title-text">{{paymentType}}</span>
          </div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">APR</div>
            <div class="dd-opt-value">{{productPayment.apr}}%</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Down</div>
            <div class="dd-opt-value">{{productPayment.totalDownPayment  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Term</div>
            <div class="dd-opt-value">{{productPayment.term}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Monthly Payment</div>
            <div class="dd-opt-value">{{productPayment.monthlyPayment  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div fxLayout="column" fxLayoutGap="20px" style="padding-bottom: 3%;padding-top: 2%; float: left;">
            <div class="pp-disclaimer">
              Protection products being presented are not included in base financing terms
            </div>
          </div>
        </div>
        <div  *ngIf="paymentType=='Lease'"  class="dd-pp-container">
          <div class="dd-para-title">
            <span class="dd-title-text">{{paymentType}}</span>
          </div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Annual Miles</div>
            <div class="dd-opt-value">{{productPayment.annualMiles}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Due At Signing</div>
            <div class="dd-opt-value">{{productPayment.dueAtSigning | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Term</div>
            <div class="dd-opt-value">{{productPayment.term}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Security Deposit</div>
            <div class="dd-opt-value">{{productPayment.securityDeposit  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Monthly Payment</div>
            <div class="dd-opt-value">{{productPayment.monthlyPayment  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div fxLayout="column" fxLayoutGap="20px" style="padding-bottom: 3%;padding-top: 2%; float: left;">
            <div class="pp-disclaimer">
              Protection products being presented are not included in base financing terms
            </div>
          </div>
        </div>
        <div *ngIf="paymentType=='Cash'" class="dd-pp-container">
          <div class="dd-para-title">
            <span class="dd-title-text">{{paymentType}}</span>
          </div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Vehicle SellingPrice</div>
            <div class="dd-opt-value">{{productPayment.vehicleSellingPrice  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Total Estimated Net Amount Due</div>
            <div class="dd-opt-value">{{productPayment.totalEstimatedNetAmountDue  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div fxLayout="column" fxLayoutGap="20px" style="padding-bottom: 3%;padding-top: 2%; float: left;">
            <div class="pp-disclaimer">
              Protection products being presented are not included in base financing terms
            </div>
          </div>
        </div>
        <!-- <div class="dd-separator-space">
        &nbsp;
      </div> -->

      </div>
    </div>

    <div>
      <div *ngIf="filteredProducts.length>0" class="title-grey-background">
        <dd-page-title  [title]="'Available Protection Products'"></dd-page-title>
      </div>
    </div>
    <div  *ngIf="filteredProducts.length>0" class="protection-product-list">
      <div  class="protection-products">
        <div  class="flex-container align-center">
          <div *ngFor="let product of filteredProducts;let i = index">
          <div class="padding">
            <rti-product-card>
              <div id="divtoScroll{{i}}" (click)="navigateToDetails(product,i)">
                <div>
                  <img style="width: 100%" src={{product.imageURL}} />
                  <!-- <div class="top-left"><img class="icon-image"
                      src="../../../../assets/images/Toyota_logo_no-text.png" />
                    FINANCIAL SERVICES</div> -->
                </div>
                <div class="monthly">
                  <label *ngIf="paymentType!='Cash'" >{{product.monthlyPayment  | currency:'USD':'symbol':'1.2-2'}} / mo</label>
                  <label *ngIf="paymentType=='Cash'" >{{product.customerPrice  | currency:'USD':'symbol':'1.2-2'}}</label>
                </div>
                <div class="product">
                  {{product.displayName}}
                </div>
                <div class="description">
                  <label [innerHTML]="product.productContent"></label>
                </div>
                <div class="row">
                  <div class="card-cloumn">
                    <p class="term">Term</p>
                    <p class="value">{{product.timeMileage}}</p>
                  </div>
                  <div class="vl"></div>
                  <div class="card-cloumn">
                    <p class="cost">Total cost</p>
                    <p class="value">{{product.customerPrice  | currency:'USD':'symbol':'1.2-2'}}</p>
                  </div>
                </div>
              </div>

            </rti-product-card>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="dd-content-margin"
      style="padding-bottom: 3%;padding-top: 2%;">
      <div class="dd-disclaimer">
        See the program agreement/ plan for complete terms and conditions. Purchase of any of the offered products is
        optional and in no way required to obtain credit. Additionally, all Toyota products are cancellable
      </div>
    </div>
  </div>
</div>